import { history } from 'services/history.js'
import { formatMoneyCents } from 'services/util'

import greenCheck from '../components/images/check-circle.svg'

import themeCss from '../components/sass/theme.module.scss'
import css from './sass/auctions.module.scss'
import auctionCardCss from './sass/auctionscards.module.scss'
import { userHasCharge } from '../util/endedAuctionUtils'

export default function AuctionEndedCardPaid({ auction, auctionUser }) {

  const owed = userHasCharge(auctionUser, auction)
  if (!owed) return <></>

  return(
    
    <div className={themeCss['box-top-green-accent-wide']} >
      <p className={auctionCardCss['auction-box-info-heading']}>Thank you for participating!</p>
      <p className={auctionCardCss['auction-box-info-text']}>See below for a summary of your items and contributions.</p>
      <div className={css['auction-ended-paiditems-container']}>
        <p className={css['auction-ended-paiditems-message']}>Payment received. <br /> Thank you!</p>
        <img className={css['auction-ended-paiditems-img']} src={greenCheck} />
      </div>
    </div>
  )
}